import { useCallback } from 'react';
import { phoneInvalidMessageMap, nonApprovedCountryMap } from './errorDictionary';
import { isValidPhoneNumber, phoneIsNotBlacklisted } from '../../utils/fieldValidators';
import useExperience from '../useExperience';
/** String-message counterpart of useValidPhone, for honest-ui inputs. */
function useValidPhoneMessage() {
    const { language } = useExperience();
    return useCallback((value) => {
        if (!phoneIsNotBlacklisted(value))
            return nonApprovedCountryMap[language];
        if (!isValidPhoneNumber(value))
            return phoneInvalidMessageMap[language];
        return undefined;
    }, [language]);
}
export default useValidPhoneMessage;
